<template>
  <vue-modal id="successPaymentWithQRCodeModal"
             classes="vue-modal-container"
             height="auto"
             name="success-payment-with-qr-code-modal"
             scrollable
             width="50%"
             @closed="modalClosed"
             @before-open="beforeOpen">
    <div class="header">
      <h3>{{ trans.header }}</h3>
      <h5>{{ trans.subHeader }}</h5>
      <button class="close-modal"
              @click="$modal.hide('success-payment-with-qr-code-modal')">
        <i class="close icon"/>
      </button>
      <div class="qr-container">
        <qrcode-vue v-if="url"
                    :value="url"
                    level="H"
                    size="200"/>
        <div v-else>Hibás link</div>
      </div>
    </div>
    <div class="content">
      <button class="confirm-btn"
              @click="$modal.hide('success-payment-with-qr-code-modal')">
        {{ trans.confirmBtnText }}<span v-if="closeAfterSecs"> ({{ closeAfterSecs }})</span>
      </button>
      <button class="wait-btn" v-if="closeAfterSecs"
              @click="closeAfterSecs = 60">
        {{ trans.waitBtnText }}
      </button>
    </div>
  </vue-modal>
</template>

<script>
import {mapState} from 'vuex'
import QrcodeVue from 'qrcode.vue';

export default {
  components: { QrcodeVue },
  data () {
    return {
      url: null,
      closeWindowWhenModalClosed: false,
      closeAfterSecs: false,
      timer: null,
    }
  },
  methods: {
    beforeOpen (event) {
      const data = event.params;
      this.url = data.url;
      this.closeWindowWhenModalClosed = data.closeWindowWhenModalClosed;
      this.closeAfterSecs = data.closeAfterSecs;

      if (this.closeAfterSecs) {
        this.timer = setInterval(() => {
          this.closeAfterSecs--;
          if (this.closeAfterSecs <= 0) {
            clearInterval(this.timer);
            this.timer = 0;
            this.$modal.hide('success-payment-with-qr-code-modal');
          }
        }, 1000);
      }
    },
    modalClosed () {
      this.url = null
      if (this.closeWindowWhenModalClosed) window.close();
      this.closeWindowWhenModalClosed = false
      if (this.$store.getters.isDigitalMode) this.$router.push('digital')
    },
  },
  computed: {
    ...mapState({
      trans: state => state.trans.successPaymentWithQRCodeModal,
    }),
  },
}
</script>

<style scoped>
.header {
  text-align: center;
}

.qr-container {
  width: 200px;
  margin: auto;
}

.confirm-btn {
  width: 100%;
  height: 50px;
  font-size: 20px;
  padding: 10px;
  border-radius: 4px;
  box-sizing: border-box;
  cursor: pointer;
  background: #f2711c;
  color: white;
}

.confirm-btn:hover {
  background: #f2711ce0;
}

.wait-btn {
  width: 100%;
  height: 50px;
  font-size: 20px;
  padding: 10px;
  border-radius: 4px;
  box-sizing: border-box;
  cursor: pointer;
  background: #ccc;
  color: black;
  margin-top: 4px;
}

</style>
